export default "__VITE_ASSET__7ac30800__"